import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanRekapTotalStok = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal),
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal),
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [merkStok, setMerkStok] = useState("");
  const [kodeJenisStok, setKodeJenisStok] = useState("");
  const [kodeGroupStok, setKodeGroupStok] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [merkStoks, setMerkStoks] = useState([]);
  const [jenisStoks, setJenisStoks] = useState([]);
  const [groupStoks, setGroupStoks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapRekapTotalStoks, setLapRekapTotalStoks] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const [jenisLaporan, setJenisLaporan] = useState("DETAIL");
  const handleChangeJenisLaporan = (event) => {
    setJenisLaporan(event.target.value);
    setLapRekapTotalStoks([]);
    setPreviewPdf(false);
  };
  const [jenisQuantity, setJenisQuantity] = useState("QTY");
  const handleChangeJenisQuantity = (event) => {
    setJenisQuantity(event.target.value);
    setLapRekapTotalStoks([]);
    setPreviewPdf(false);
  };

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  let merkStokOptions = merkStoks.map((merkStok) => ({
    label: `${merkStok.merkStok}`,
  }));
  let jenisStokOptions = jenisStoks.map((jenisStok) => ({
    label: `${jenisStok.kodeJenisStok} - ${jenisStok.namaJenisStok}`,
  }));
  let groupStokOptions = groupStoks.map((groupStok) => ({
    label: `${groupStok.kodeGroupStok} - ${groupStok.namaGroupStok}`,
    jenisStok: `${groupStok.jenisstok.kodeJenisStok} - ${groupStok.jenisstok.namaJenisStok}`,
  }));

  useEffect(() => {
    getMerkStokData();
    getJenisStokData();
    getGroupStokData();
  }, []);

  const getMerkStokData = async () => {
    const response = await axios.post(`${tempUrl}/stoksMerk`, {
      _id: user.id,
      token: user.token,
    });
    setMerkStoks(response.data);
  };

  const getJenisStokData = async () => {
    const response = await axios.post(`${tempUrl}/jenisStoks`, {
      _id: user.id,
      token: user.token,
    });
    setJenisStoks(response.data);
  };

  const getGroupStokData = async () => {
    const response = await axios.post(`${tempUrl}/groupStoks`, {
      _id: user.id,
      token: user.token,
    });
    setGroupStoks(response.data);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanRekapTotalStok",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanRekapTotalStok = await axios.post(
        `${tempUrl}/laporanRekapTotalStok`,
        {
          jenisQuantity,
          dariTanggal,
          sampaiTanggal,
          merkStok,
          kodeJenisStok: kodeJenisStok.split(" ", 1)[0],
          kodeGroupStok: kodeGroupStok.split(" ", 1)[0],
          kodeCabang,
          _id: user.id,
          token: user.token,
        },
      );
      setLapRekapTotalStoks(laporanRekapTotalStok.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  let tempTotalSubtotalSaldoAwal = 0;
  let tempTotalSubtotalMasukPembelian = 0;
  let tempTotalSubtotalMasukStockOpname = 0;
  let tempTotalSubtotalKeluarStockOpname = 0;
  let tempTotalSubtotalKeluarEntryRacikan = 0;
  let tempTotalSaldoAkhir = 0;

  Object.entries(lapRekapTotalStoks).map(([groupTitle, stokRows]) => {
    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={8}
        >
          Grup : {groupTitle}
        </td>
      </tr>,
    );

    let tempSubtotalSubtotalSaldoAwal = 0;
    let tempSubtotalSubtotalMasukPembelian = 0;
    let tempSubtotalSubtotalMasukStockOpname = 0;
    let tempSubtotalSubtotalKeluarStockOpname = 0;
    let tempSubtotalSubtotalKeluarEntryRacikan = 0;
    let tempSubtotalSaldoAkhir = 0;

    stokRows.map((row, index) => {
      tempSubtotalSubtotalSaldoAwal += row.subtotalSaldoAwal;
      tempSubtotalSubtotalMasukPembelian += row.subtotalMasukPembelian;
      tempSubtotalSubtotalMasukStockOpname += row.subtotalMasukMutasiStok;
      tempSubtotalSubtotalKeluarStockOpname += row.subtotalKeluarPenjualan;
      tempSubtotalSubtotalKeluarEntryRacikan += row.subtotalKeluarEntryRacikan || 0;
      tempSubtotalSaldoAkhir += row.subtotalSaldoAkhir;

      tempTotalSubtotalSaldoAwal += row.subtotalSaldoAwal;
      tempTotalSubtotalMasukPembelian += row.subtotalMasukPembelian;
      tempTotalSubtotalMasukStockOpname += row.subtotalMasukMutasiStok;
      tempTotalSubtotalKeluarStockOpname += row.subtotalKeluarPenjualan;
      tempTotalSubtotalKeluarEntryRacikan += row.subtotalKeluarEntryRacikan || 0;
      tempTotalSaldoAkhir += row.subtotalSaldoAkhir;

      list.push(
        <tr style={tableText}>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {index + 1}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.stokTitle}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.items[0].stok.satuanKecilStok}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalSaldoAwal.toLocaleString("en-EN")
              : row.subtotalSaldoAwal}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalMasukPembelian.toLocaleString("en-EN")
              : row.subtotalMasukPembelian}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalMasukMutasiStok.toLocaleString("en-EN")
              : row.subtotalMasukMutasiStok}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalKeluarPenjualan.toLocaleString("en-EN")
              : row.subtotalKeluarPenjualan}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? (row.subtotalKeluarEntryRacikan || 0).toLocaleString("en-EN")
              : row.subtotalKeluarEntryRacikan || 0}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.subtotalSaldoAkhir.toLocaleString("en-EN")
              : row.subtotalSaldoAkhir}
          </td>
        </tr>,
      );
    });

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={3}
        >
          Sub Total : {groupTitle}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalSaldoAwal.toLocaleString("en-EN")
            : tempSubtotalSubtotalSaldoAwal}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalMasukPembelian.toLocaleString("en-EN")
            : tempSubtotalSubtotalMasukPembelian}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalMasukStockOpname.toLocaleString("en-EN")
            : tempSubtotalSubtotalMasukStockOpname}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalKeluarStockOpname.toLocaleString("en-EN")
            : tempSubtotalSubtotalKeluarStockOpname}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSubtotalKeluarEntryRacikan.toLocaleString("en-EN")
            : tempSubtotalSubtotalKeluarEntryRacikan}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalSaldoAkhir.toLocaleString("en-EN")
            : tempSubtotalSaldoAkhir}
        </td>
      </tr>,
    );
  });

  list.push(
    <tr style={{ ...tableText, fontWeight: "bold" }}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={3}
      >
        Grand Total :
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalSaldoAwal.toLocaleString("en-EN")
          : tempTotalSubtotalSaldoAwal}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalMasukPembelian.toLocaleString("en-EN")
          : tempTotalSubtotalMasukPembelian}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalMasukStockOpname.toLocaleString("en-EN")
          : tempTotalSubtotalMasukStockOpname}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalKeluarStockOpname.toLocaleString("en-EN")
          : tempTotalSubtotalKeluarStockOpname}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSubtotalKeluarEntryRacikan.toLocaleString("en-EN")
          : tempTotalSubtotalKeluarEntryRacikan}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalSaldoAkhir.toLocaleString("en-EN")
          : tempTotalSaldoAkhir}
      </td>
    </tr>,
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanRekapTotalStok",
    sheet: "LaporanRekapTotalStok",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Rekap Total Stok</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Jenis Laporan
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="DETAIL"
                value={jenisLaporan}
                onChange={handleChangeJenisLaporan}
              >
                <FormControlLabel
                  value="DETAIL"
                  control={<Radio />}
                  label="Detail"
                  disabled
                />
                <FormControlLabel
                  value="REKAP PER GRUP"
                  control={<Radio />}
                  label="Rekap Per Grup"
                  disabled
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Jenis Quantity
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="RUPIAH"
                value={jenisQuantity}
                onChange={handleChangeJenisQuantity}
              >
                <FormControlLabel
                  value="RUPIAH"
                  control={<Radio />}
                  label="Rupiah"
                  disabled={user.tipeUser === "ADMIN" && true}
                />
                <FormControlLabel
                  value="QTY"
                  control={<Radio />}
                  label="Qty"
                  disabled={user.tipeUser === "ADMIN" && true}
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <hr />
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={user.tipeUser !== "OWNER/DIREKSI" && error && kodeCabang.length === 0}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Jenis Stok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={jenisStokOptions}
                    renderInput={(params) => (
                      <TextField
                        placeholder="SEMUA JENIS STOK"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeJenisStok(value.label);
                        setKodeGroupStok("");
                      } else {
                        setKodeJenisStok("");
                        setKodeGroupStok("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeJenisStok}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Group Stok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={groupStokOptions}
                    renderInput={(params) => (
                      <TextField
                        placeholder="SEMUA GROUP STOK"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeGroupStok(value.label);
                        setKodeJenisStok(value.jenisStok);
                      } else {
                        setKodeGroupStok("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeGroupStok}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Merk Stok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={merkStokOptions}
                    renderInput={(params) => (
                      <TextField
                        placeholder="SEMUA MERK STOK"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setMerkStok(value.label);
                      } else {
                        setMerkStok("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={merkStok}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Rekap Total Stok
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Stok : {kodeJenisStok ? kodeJenisStok : "SEMUA"}</p>
          <p>Cabang : {namaCabang || "SEMUA CABANG"}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  NO.
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  STOK
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SAT.
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SALDO AWAL
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={2}
                >
                  MASUK
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={2}
                >
                  KELUAR
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  SALDO AKHIR
                </th>
              </tr>
              <tr>
                <th style={{ border: "1px solid black" }}>PEMBELIAN</th>
                <th style={{ border: "1px solid black" }}>HSO (TAMBAH)</th>
                <th style={{ border: "1px solid black" }}>HSO (KURANG)</th>
                <th style={{ border: "1px solid black" }}>ENTRY RACIKAN</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanRekapTotalStok;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const colorRed = {
  color: "red",
};
